import { DataParent, IAggregatedDataAccount } from './portfolio-management.types';

export function updateOrCreateAggregatedData(
  updatedDataAccounts: IAggregatedDataAccount[],
  dataParent: DataParent,
  updateData: (account: IAggregatedDataAccount) => void,
  createData: () => IAggregatedDataAccount,
): IAggregatedDataAccount[] {
  const existingAccount = updatedDataAccounts.find((acc) => acc.dataParent === dataParent);
  if (existingAccount) {
    updateData(existingAccount);
  } else {
    updatedDataAccounts.push(createData());
  }
  return updatedDataAccounts;
}
